<template>
  <div class="hello" style="background-color: #E8E8E8; min-height: 100vh;">
    <div
      v-if="qx"
      style="background-color: #fff; padding: 10px 10px;border-radius: 4px;min-height: 100vh;"
    >
      <div>
        <div style="text-align: left; font-size: 16px; color: #51A6FF">
          <span style="color: #51A6FF;">|</span>
          <span>本项目涉密，您没有权限查看！</span>
        </div>
      </div>
    </div>
    <div v-else>
      <div
        style="color: #51A6FF; font-size: 18px; font-weight: 600;text-align: left; padding: 10px 10px;"
      >
        <van-row
          gutter="10"
          type="flex"
          justify="space-between"
          style="flex-wrap: wrap;"
        >
          <van-col span="24">{{ project.xmmc }}</van-col>
          <van-col
            v-if="iffocus == 0"
            span="24"
            style="font-size: 16px; font-weight: 600;text-align: right;padding-right: 20px;"
            @click="focusMethod(project.projectId)"
            ><van-icon name="star-o" /><span
              style="font-size: 16px; font-weight: 400;height: 100px;"
              >收藏</span
            ></van-col
          >
          <van-col
            v-else
            span="24"
            style="font-size: 16px; font-weight: 600;text-align: right;padding-right: 20px;color: #FFD700;"
            @click="cancelFocus(project.projectId)"
            ><van-icon name="star" /><span
              style="font-size: 16px; font-weight: 400;"
              >收藏</span
            ></van-col
          >
        </van-row>
      </div>
      <div style="padding: 0px 10px;">
        <div
          style="background-color: #fff; padding: 10px 10px;border-radius: 4px;"
        >
          <div>
            <div style="text-align: left; font-size: 16px; color: #000">
              <span style="color: #51A6FF;">|</span>
              <span>年度目标</span>
            </div>
            <div
              v-if="project.ndmb != ''"
              style="text-align: left; font-size: 14px; color: #000; padding: 10px 10px;"
            >
              {{ project.ndmb }}
            </div>
            <div
              v-else
              style="text-align: left; font-size: 14px; color: #E8E8E8; padding: 10px 10px;"
            >
              还未录入年度目标！
            </div>
          </div>
        </div>
        <div v-if="chartsShow.length > 0 || labelShow.length > 0">
          <div
            style="margin-top: 10px; background-color: #fff; padding: 10px 10px;border-radius: 4px;"
          >
            <div>
              <div style="text-align: left; font-size: 16px; color: #000">
                <span style="color: #51A6FF;">|</span>
                <span>月度时间表</span>
              </div>
              <van-row
                type="flex"
                justify="space-around"
                style="margin: 0px 0px;flex-wrap: wrap;"
              >
                <van-col
                  span="4"
                  style="text-align: center; margin-top: 10px;"
                  v-for="(item, index) in months"
                  :key="index + '-0'"
                >
                  <div
                    v-if="monthSelect[index] == 1"
                    style="background-color: #FFCC00; width: 40px; height: 40px; line-height: 40px;text-align: center;border-radius: 4px;color: #fff;"
                    @click="selectMethod(index)"
                  >
                    {{ item }}
                  </div>
                  <div
                    v-else
                    :style="
                      'background-color: ' +
                        checkColor(index) +
                        ';width: 40px; height: 40px; line-height: 40px;text-align: center;border-radius: 4px;color: #fff;'
                    "
                    @click="selectMethod(index)"
                  >
                    {{ item }}
                  </div>
                </van-col>
              </van-row>
            </div>
          </div>
          <div
            v-if="chartsShow.length > 0"
            style="margin-top: 10px; background-color: #fff; padding: 10px 10px;border-radius: 4px;"
          >
            <div>
              <div style="text-align: left; font-size: 16px; color: #000">
                <span style="color: #51A6FF;">|</span>
                <span>进度详细({{ dateTitle }})</span>
              </div>
              <div
                v-for="(item6, index6) in chartsShow"
                :key="'index6-' + index6"
              >
                <van-row
                  type="flex"
                  style="text-align: left; font-size: 14px; color: #000; padding: 20px 10px 0px 10px;"
                >
                  <van-col
                    span="18"
                    style="font-size: 14px; font-weight: 600;"
                    >{{ item6.name }}</van-col
                  >
                </van-row>
                <van-row
                  type="flex"
                  style="text-align: left; font-size: 14px; color: #000;flex-wrap: wrap;padding: 0 10px;"
                >
                  <van-col
                    span="10"
                    style="font-size: 14px; font-weight: 200; padding: 10px 0px 0px 0px; "
                    >月度进度：{{
                      item6.ydjd[selectIndex] == 'Infinity'
                        ? 0
                        : item6.ydjd[selectIndex]
                    }}%</van-col
                  >
                  <van-col span="14">
                    <div
                      style="background-color: #E8E8E8; color: #fff;margin: 10px 0px;border-radius: 16px;overflow: hidden;"
                    >
                      <div
                        :style="
                          'width:' +
                            item6.ydjd[selectIndex] +
                            '%; background-color: #2ECCBD;text-align: center;font-size: 10px; font-weight: 200;'
                        "
                      >
                        &nbsp;
                      </div>
                    </div>
                  </van-col>
                  <van-col
                    span="10"
                    style="font-size: 14px; font-weight: 200; padding: 10px 0px 0px 0px; "
                    >年度进度：{{ item6.ndjd[selectIndex] }}%</van-col
                  >
                  <van-col span="14">
                    <div
                      style="background-color: #E8E8E8; color: #fff;margin: 10px 0px;border-radius: 16px;overflow: hidden; width:100%;"
                    >
                      <div
                        :style="
                          'width:' +
                            item6.ndjd[selectIndex] +
                            '%; background-color: #2ECCBD;text-align: center;font-size: 10px; font-weight: 200;'
                        "
                      >
                        &nbsp;
                      </div>
                    </div>
                  </van-col>
                </van-row>
              </div>
            </div>
          </div>
          <div
            style="margin-top: 10px; background-color: #fff; padding: 10px 10px;border-radius: 4px;"
          >
            <div>
              <div style="text-align: left; font-size: 16px; color: #000">
                <span style="color: #51A6FF;">|</span>
                <span>完成情况</span>
              </div>
              <van-row
                type="flex"
                style="text-align: left; font-size: 14px; color: #000; padding: 10px 10px 0px 10px;flex-wrap: wrap;"
              >
                <van-col
                  span="24"
                  style="font-size: 14px; font-weight: 200; padding: 10px 0px 0px 0px;"
                >
                  <div
                    v-for="(item1, index1) in chartsShow"
                    :key="index1 + '-1'"
                  >
                    <div>
                      <span style="color: #007ACC">┃</span> {{ item1.name }}
                    </div>
                    <div
                      class="myChart"
                      style="width: 100%; height: 260px;"
                    ></div>
                  </div>
                  <div
                    v-for="(item4, index4) in labelShow"
                    :key="index4 + '-4'"
                  >
                    <van-row
                      v-if="
                        item4.targetList[selectIndex] == 1 ||
                          item4.valueList[selectIndex] == 1
                      "
                      type="flex"
                      justify="space-between"
                      style="margin-bottom: 10px;"
                    >
                      <van-col span="18"
                        ><span style="color: #007ACC">┃</span
                        >{{ item4.name }}</van-col
                      >
                      <van-col span="6" v-if="item4.valueList[selectIndex] == 1"
                        ><van-tag type="success">完成</van-tag></van-col
                      >
                      <van-col span="6" v-else
                        ><van-tag type="danger">未完成</van-tag></van-col
                      >
                      <van-steps
                        direction="vertical"
                        :active="0"
                        active-color="#969799"
                        active-icon="circle"
                        style="margin-top: 10px;"
                      >
                        <van-step
                          v-for="(item9, index9) in item4.qksmList"
                          :key="'index9-' + index9"
                        >
                          <van-row
                            v-for="(item10, index10) in item9.lclyqksmnoteList"
                            :key="'index10-' + index10"
                            type="flex"
                            style="text-align: left; font-size: 14px; color: #000; padding: 0px 10px 0px 10px;flex-wrap: wrap;"
                          >
                            <van-col
                              span="24"
                              style="font-size: 14px; font-weight: 200;"
                              >{{ parseTime(item10.createTime) }}</van-col
                            >
                            <van-col
                              span="24"
                              style="font-size: 14px; font-weight: 200; padding-top: 10px;"
                              >{{ item10.note }}</van-col
                            >
                          </van-row>
                          <van-row
                            v-for="(item11, index11) in item9.lclyqksmdocList"
                            :key="'index11-' + index11"
                            type="flex"
                            style="text-align: left; font-size: 14px; color: #000; padding: 0px 10px 0px 10px;flex-wrap: wrap;"
                          >
                            <van-col
                              span="24"
                              style="font-size: 14px; font-weight: 200; padding-top: 10px;color: blue;"
                              @click="downFile(item11.url)"
                              >{{ item11.name }}</van-col
                            >
                          </van-row>
                        </van-step>
                      </van-steps>
                    </van-row>
                  </div>
                </van-col>
              </van-row>
              <div v-if="ifOwner == 1 || ifOwner == 2">
                <div
                  style="margin: 40px 10px 40px 10px;border-top:1px solid #E8E8E8"
                ></div>
                <van-cell-group>
                  <van-field
                    v-model="message"
                    type="textarea"
                    placeholder="请输入留言"
                    rows="2"
                    autosize
                  />
                </van-cell-group>
                <div
                  style="text-align: center; margin-top: 20px; margin-left: 10px;"
                >
                  <van-tag
                    v-if="ifOwner == 2"
                    color="#0959E4"
                    style="padding: 4px 40px;"
                    @click="psMethod()"
                    :loading="buttonLoading"
                    >批示</van-tag
                  >
                  <van-tag
                    v-else
                    color="#0959E4"
                    style="padding: 4px 40px;"
                    @click="psMethod()"
                    :loading="buttonLoading"
                    >发送</van-tag
                  >
                </div>
                <van-steps
                  direction="vertical"
                  :active="0"
                  active-color="#969799"
                  active-icon="circle"
                  style="margin-top: 40px;"
                >
                  <van-step
                    v-for="(item6, index6) in messageList"
                    :key="index6 + '-6'"
                  >
                    <van-row
                      type="flex"
                      style="text-align: left; font-size: 14px; color: #000; padding: 0px 10px 0px 10px;flex-wrap: wrap;"
                    >
                      <van-col
                        span="10"
                        style="font-size: 14px; font-weight: 600;"
                        >{{ item6.psryXm }}</van-col
                      >
                      <van-col
                        span="14"
                        style="font-size: 14px; font-weight: 200;"
                        >{{ parseTime(item6.createTime) }}</van-col
                      >
                      <van-col
                        span="24"
                        style="font-size: 14px; font-weight: 200; padding-top: 10px;"
                        >{{ item6.psnr }}</van-col
                      >
                    </van-row>
                  </van-step>
                </van-steps>
              </div>
            </div>
            <div style="height: 100px;"></div>
          </div>
        </div>
        <div v-else>
          <div
            style="background-color: #fff; padding: 10px 10px;border-radius: 4px;margin-top: 10px;"
          >
            <div>
              <div style="text-align: center; font-size: 16px; color: #E8E8E8">
                <span>项目还未创建指标！</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let Echarts = require('echarts/lib/echarts') //基础实例 注意不要使用import
require('echarts/lib/chart/line') //按需引入 bar = 柱状图
require('echarts/lib/component/title')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/legend')
require('echarts/lib/component/toolbox')
require('echarts/lib/component/grid')
import zdqdUser from '../api/zdqd'
import GLOBAL from '../settings'
import { parseTime } from '../utils/index'
import { Toast } from 'vant'
import { ImagePreview } from 'vant'
import crudUser from '../api/user'
import { addBaseAplus } from '../utils/baseAplus'
import dd from 'gdt-jsapi'
export default {
  name: 'Zdqd',
  data() {
    return {
      active: '1000',
      selectIndex: 0,
      dateTitle: '',
      chart: null,
      value: '',
      activeNames: '',
      months: [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月'
      ],
      monthSelect: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      charts: [0, 0, 0, 0],
      monthData: [],
      project: {},
      valueCharts: [],
      chartsShow: [],
      labelShow: [],
      pageData: {
        target: [],
        valueList: [],
        doc: [],
        qksm: []
      },
      message: '',
      messageList: [],
      ifOwner: 0,
      buttonLoading: true,
      iffocus: 0,
      qx: false,
      zts: []
    }
  },
  mounted() {
    setTimeout(() => {
      this.initTotal()
    }, 500)
  },
  created() {
    zdqdUser.getProjectDetail(this.$route.query.id).then(res => {
      if (res.status == 10401) {
        Toast.fail(res.desc)
        this.qx = true
      } else {
        this.project = res.data.project
        this.valueCharts = res.data.valueCharts
        this.iffocus = res.data.iffocus
        this.ifOwner = res.data.ifOwner
        zdqdUser.getPs(this.project.projectId).then(res => {
          this.messageList = res.data
        })
        this.chartsShow = res.data.valueCharts.filter(item => {
          return item.lx == 1
        })
        this.labelShow = res.data.valueCharts.filter(item => {
          return item.lx == 0
        })

        this.chartsShow.forEach(item => {
          item.ydjd = []
          item.ndjd = []
          for (var i = 0; i < 12; i++) {
            if (item.valueList[i] == undefined || item.valueList[i] == '') {
              item.ydjd.push(0)
              item.ndjd.push(0)
            } else {
              item.ydjd.push(
                ((100 * item.valueList[i]) / item.targetList[i]).toFixed(2)
              )
              item.ndjd.push(
                ((100 * item.valueList[i]) / item.ndmb[i]).toFixed(2)
              )
            }
          }
        })
        console.log('this.chartsShow----------', this.chartsShow)

        var today = new Date()
        // 根据targetList最后一个1，来确定最新月份数据显示
        // var lastMonthList = this.labelShow.map(x=>x.targetList.lastIndexOf(1))
        // var month = lastMonthList.sort((x,y)=>y - x)[0]

        var ztsBitmap = []
        res.data.zts.forEach(x => {
          if (x == 0) {
            ztsBitmap.push(0)
          } else {
            ztsBitmap.push(1)
          }
        })

        var month = ztsBitmap.lastIndexOf(1)
        this.selectIndex = month
        this.monthSelect[month] = 1
        this.dateTitle = today.getFullYear() + '年' + (month + 1) + '月'

        // this.pageData = this.monthData[today.getMonth()]
        // this.selectIndex = today.getMonth()
        // this.monthSelect[today.getMonth()] = 1
        // this.dateTitle = today.getFullYear() + '年' + (this.selectIndex+1) + '月'
        this.zts = res.data.zts
      }
    })
  },
  methods: {
    parseTime,
    focusMethod(id) {
      // alert(123)
      zdqdUser.focusMethod(id).then(res => {
        Toast.success('收藏成功！')
        this.iffocus = 1
      })
    },
    cancelFocus(id) {
      // alert(456)
      zdqdUser.cancelFocus(id).then(res => {
        Toast.success('取消收藏成功！')
        this.iffocus = 0
      })
    },
    initTotal() {
      var roseCharts = document.getElementsByClassName('myChart')
      for (var i = 0; i < roseCharts.length; i++) {
        this.init(roseCharts[i], i)
      }
    },
    init(oneDiv, i) {
      var that = this
      //2.初始化
      var chart = Echarts.init(oneDiv)
      //3.配置数据
      let option = {
        title: {
          // text: '1-12月' + that.chartsShow[i].name + '展示',
          x: 'center',
          textStyle: {
            fontSize: 12
          }
        },
        grid: {
          top: '20%',
          bottom: '20%',
          left: '15%',
          right: '0%'
        },
        legend: {
          orient: 'horizontal',
          x: 'center',
          top: '10%',
          data: ['年度目标', '月度目标', '当月值'],
          textStyle: {
            fontSize: 10
          }
        },
        xAxis: {
          data: [
            '1月',
            '2月',
            '3月',
            '4月',
            '5月',
            '6月',
            '7月',
            '8月',
            '9月',
            '10月',
            '11月',
            '12月'
          ],
          axisLabel: {
            interval: 0
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            margin: 2,
            formatter: function(value, index) {
              if (value >= 10000 && value < 10000000) {
                value = value / 10000 + '万'
              } else if (value >= 10000000 && value < 100000000) {
                value = value / 10000000 + '千万'
              } else if (value >= 100000000) {
                value = value / 100000000 + '亿'
              }
              return value
            }
          }
        },
        series: [
          {
            name: '年度目标',
            data: that.chartsShow[i].ndmb,
            type: 'line'
          },
          {
            name: '月度目标',
            data: that.chartsShow[i].targetList,
            type: 'line'
          },
          {
            name: '当月值',
            data: that.chartsShow[i].valueList,
            type: 'line'
          }
        ],
        color: ['rgb(46, 204, 190)', 'rgb(86, 170, 255)', 'rgb(243, 115, 68)']
      }
      // 4.传入数据
      chart.setOption(option)
    },
    psMethod() {
      if (this.message == '') {
        Toast.fail('批示信息不能为空！')
      } else {
        this.buttonLoading = false
        var params = {
          projectId: this.project.projectId,
          psnr: this.message
        }
        zdqdUser.psMethod(params).then(res => {
          zdqdUser.getPs(this.project.projectId).then(res1 => {
            this.messageList = res1.data
          })
          Toast.success('批示成功！')
          this.message = ''
          this.buttonLoading = true
        })
      }
    },
    showMethod(item) {
      alert(GLOBAL.baseUrl + item.url)
      crudUser.getJsapiToken().then(res1 => {
        var jsapitoken = res1.data
        dd.authConfig({
          ticket: jsapitoken,
          jsApiList: ['alert', 'chooseContactWithComplexPicker', 'previewDoc']
        })
          .then(res => {
            dd.previewDoc({
              fileName: item.name,
              fileUrl: GLOBAL.baseUrl + item.url
            })
              .then(res => {})
              .catch(err => {
                alert(JSON.stringify(err))
              })
          })
          .catch(err => {
            alert()
          })
      })
    },
    selectMethod(index) {
      this.selectIndex = index
      this.monthSelect = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      this.monthSelect[index] = 1
      this.pageData = this.monthData[index]
      var today = new Date()
      this.dateTitle =
        today.getFullYear() + '年' + (this.selectIndex + 1) + '月'
    },
    checkColor(index) {
      if (this.zts[index] == 0) {
        return 'rgb(150, 150, 150)'
      } else if (this.zts[index] == 1) {
        return 'rgb(243, 115, 68)'
      } else if (this.zts[index] == 2) {
        return 'rgb(46, 204, 190)'
      } else if (this.zts[index] == 3) {
        return 'rgb(86, 170, 255)'
      } else if (this.zts[index] == 4) {
        return 'rgb(150, 150, 150)'
      }
    },
    downFile(url) {
      window.location.href = url
      $router.go(-1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.van-cell.van-field {
  background-color: #E8E8E8;
  border-radius: 8px;
}
.myChart {
  position: relative;
  left: -12px;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectDetail.vue